import { Box, Divider, Heading, Table, TableContainer, Tbody, Td, Th, Thead, Tr, Text, useToast, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, Button, useDisclosure, Flex, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, FormControl, FormLabel, Input, ModalFooter} from '@chakra-ui/react'
import { MdDelete } from 'react-icons/md';
import { MdUpdate } from 'react-icons/md';
import { MdPaid } from 'react-icons/md';
import axios from 'axios'
import React, { useState } from 'react'
// import Auth from './Auth'

const TenureDetailsTable = ({head, data, tenureType,deleteRenderMe, tenureId}) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [issueDueDateAmount, setIssueDueDateAmount ] = useState("")
    const [isOpen1, setIsOpen1] = useState(false)
    const [isOpen2, setIsOpen2] = useState(false)
    const onClose1 = () => setIsOpen1(false)
    const onClose2 = () => setIsOpen2(false)
    const onOpen1 = () => setIsOpen1(true)
    const onOpen2 = () => setIsOpen2(true)
    const toast = useToast()



    const tableBorder = {
        borderCollapse: 'separat',
        borderSpacing: '0px',
        borderRadius: '3px',
        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.25)'
    }
    const tableRowBorder = {
        border: '1px solid rgba(0, 0, 0, 0.17)',
        bgColor: 'white',
        _last: {
            borderRight: 'unset'
        },
        _first: {
            borderLeft: 'unset'
        }    
    }

    //Update tenure ticket on payment success

    // const tenurePaymentSuccessTicket = async(id) => {
    //         let data = {ids:[id]}

    //         let config = {
    //         method: 'post',
    //         maxBodyLength: Infinity,
    //         url: `${process.env.REACT_APP_RALCO_API_URL}/api/freshdesk/tenure-payment-success-ticket`,
    //         headers: { 
    //           'Content-Type': 'application/json'
    //         },
    //         data : data
    //       };
          
    //       let response = await axios.request(config)
    //       return response.data;     
    // }
    
    // Change Invoice Status
    const changeInvoiceStatus = (id, total, date, invoiceName, title) => {
        let data = JSON.stringify({
            "invoiceId": `${id}`,
            "data": {
              "invoice": {
                "statusId": `${title}`
              }
            }
          });
          
          let config = {
            method: 'patch',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_RALCO_API_URL}/api/invoice/${id}`,
            headers: { 
              'Content-Type': 'application/json'
            },
            data : data
          };
          
          axios.request(config)
          .then((response) => {
            console.log(JSON.stringify(response.data));
            deleteRenderMe();
            // tenurePaymentSuccessTicket(id).then((resp) => {
            //   console.log(resp, "yyy")
            //     if (resp && resp.error === false && !(resp.data === null)) {
            //       toast({
            //         title: `Date : ${new Date(date).toLocaleDateString(
            //           "en-IN"
            //         )} Invoice #${invoiceName} is ${title}`,
            //         status: "success",
            //         position: "top",
            //         duration: 3000,
            //         isClosable: true,
            //       });
            //       deleteRenderMe();
            //     } else {
            //       console.log("enter here")
            //       toast({
            //         title: `Oops we are facing some temporary issue with your request`,
            //         status: "error",
            //         position: "top",
            //         duration: 3000,
            //         isClosable: true,
            //       });
            //     }
            //   })
            //   .catch((err) => {
            //     console.log(err);
            //     toast({
            //       title: `Oops we are facing some temporary issue with your request`,
            //       status: "error",
            //       position: "top",
            //       duration: 3000,
            //       isClosable: true,
            //     });
            //   });
          })
          .catch((error) => {
            console.log(error)
            toast({
                title: `Oops we are facing some temporary issue with your request`,
                status: 'error',
                position: 'top',
                duration: 3000,
                isClosable: true,
              })
          });
          
    }

    // ### ISSUE DUE DATE INVOICE ###
    const issueDueDate = (id, total, invoiceName) => {
        
        let data = JSON.stringify({
            "invoiceId": `${id}`,
            "dueDateAmount": `${issueDueDateAmount}`,
            "newInvoiceTotalPayable": Number((Number(issueDueDateAmount) + Number(total)) * 1).toFixed(2),
            "invoiceRelation": "DUE_DATE_INVOICE"
          });
          
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_RALCO_API_URL}/api/invoice/issue/due-date-invoice`,
            headers: { 
              'Content-Type': 'application/json'
            },
            data : data
          };
          
          axios.request(config)
          .then((response) => {
            console.log(JSON.stringify(response.data));
            deleteRenderMe()
            toast({
                title: `#${invoiceName} - Due Date Amount Issued Successfully`,
                status: 'success',
                position: 'top',
                duration: 3000,
                isClosable: true,
              })
          })
          .catch((error) => {
            console.log(error);
            toast({
                title: `Oops we are facing some temporary issue with your request`,
                status: 'error',
                position: 'top',
                duration: 3000,
                isClosable: true,
              })
          });
    }

    console.log(data, 'xxlkcxsdkljkls')

    return (
        <Box my={5} p={3}>
            <Heading size={'md'} mb={2}>Invoice Details</Heading>
            <Divider size={1} my={2} borderBottomColor={'black'} />
            {data.length > 0 ?
            <TableContainer my={3} sx={tableBorder}>
                    <Table variant={'simple'} size={'xs'} >
                        <Thead borderRadius={'3px 3px 0px 0px'} bgColor={'rgba(226, 223, 223, 1)'}>
                            <Tr>
                                {head.map((h, i) => (
                                    <Th p={3} key={i} _last={{borderRight: 'unset'}} borderRight={'1px solid rgba(0, 0, 0, 0.17)'} fontSize={'9px'}>{h}</Th>
                                ))}
                            </Tr>
                        </Thead>
                        <Tbody>
                           
                            {data.map((d, i) => (
                                
                                <Tr key={i}>
                                    <Td sx={tableRowBorder} fontSize={'xs'} p={3} color={d?.zone === "DUE_DATE_INVOICE" ? '#B31312' : "black"} >#{d.statusId === "PAID" ? d?.invoiceIdentifier || '----' : d?.invoiceName || '----'}</Td>
                                    <Td sx={tableRowBorder} fontSize={'xs'} p={3} >{new Date(d.invoiceDate).toLocaleDateString('en-IN')}</Td>
                                    {/* <Td sx={tableRowBorder} fontSize={'xs'} p={3} >{tenureType === 'MONTHLY' ? new Date(d.dueDate).toLocaleDateString('en-IN') : '----'}</Td>
                                    <Td sx={tableRowBorder} fontSize={'xs'} p={3} >{d.cutOffDate === null ? '----' : new Date(d.cutOffDate).toLocaleDateString('en-IN')}</Td> */}
                                    <Td sx={tableRowBorder} fontSize={'xs'} p={3} >₹{d.invoiceTotalPayable}</Td>
                                    <Td sx={tableRowBorder} fontSize={'xs'} p={3} >₹{d.invoiceTotal}</Td>
                                    <Td sx={tableRowBorder} fontSize={'xs'} p={3} >
                                    <Flex flexDirection={'column'}>
                                    <Box>
                                        {`${tenureType.charAt(0).toUpperCase() + tenureType.slice(1).toLowerCase()}`}
                                    </Box>
                                    {tenureType === 'WEEKLY' && 
                                    <Box>
                                        {((d.comment === tenureId) || (d.description === 'weekly-tenure-extension-invoice')) ? '(Weekly Tenure Extension)' : null}
                                    </Box>
                                    }
                                    </Flex>
                                    </Td>
                                    <Td sx={tableRowBorder} fontSize={'xs'} p={3} letterSpacing={'0.2px'} color={d.statusId === "CANCELLED" ? '#B31312' : d.statusId === "PAID" ? "#38a169" : d.statusId === "ISSUED" ? "#3190dc" : "black"} fontWeight={'semibold'}>{d?.statusId?.charAt(0).toUpperCase() + d?.statusId?.slice(1).toUpperCase()}</Td>
                                    <Td sx={tableRowBorder} fontSize={'xs'} p={3}>
                                        <Flex>
                                            {(d?.statusId !== "PAID" && d?.statusId !== "INACTIVE" && d?.statusId !== "CANCELLED") && <MdDelete color={'#B31312'} fontSize={'22px'} cursor={'pointer'} onClick={ () => {
                                                window.sessionStorage.setItem('invoiceId', JSON.stringify(d.id))                                               
                                                window.sessionStorage.setItem('newInvoiceTPAmount', JSON.stringify(d.invoiceTotalPayable))                                               
                                                onOpen()
                                                }}/>}
                                            {(d?.statusId !== "PAID" && d?.statusId !== "INACTIVE" && d?.statusId !== "CANCELLED" && d?.zone !== "DUE_DATE_INVOICE") && <MdUpdate color={'gray'} fontSize={'22px'} cursor={'pointer'} onClick={() => {
                                                window.sessionStorage.setItem('invoiceId', JSON.stringify(d.id))
                                                window.sessionStorage.setItem('newInvoiceTPAmount', JSON.stringify(d.invoiceTotalPayable))
                                                onOpen1()
                                                }}/>}
                                            {(d?.statusId !== "PAID" && d?.statusId !== "INACTIVE" && d?.statusId !== "CANCELLED") && <MdPaid color={'green'} fontSize={'22px'} cursor={'pointer'} onClick={() => {
                                                window.sessionStorage.setItem('invoiceId', JSON.stringify(d.id))
                                                window.sessionStorage.setItem('newInvoiceTPAmount', JSON.stringify(d.invoiceTotalPayable))
                                                onOpen2()
                                                }}/>}
                                        </Flex>
                                    {/* INACTIVE STATUS ALERT */}
                                    <AlertDialog
                                            motionPreset='slideInBottom'
                                            onClose={onClose}
                                            isOpen={isOpen}
                                            isCentered
                                    >
                                        <AlertDialogOverlay>
                                        <AlertDialogContent>
                                            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                                                Cancel Invoice
                                            </AlertDialogHeader>

                                            <AlertDialogBody>
                                                Are you sure? You can't undo this action afterwards.
                                            </AlertDialogBody>

                                            <AlertDialogFooter>
                                            <Button onClick={onClose}>
                                                NO
                                            </Button>
                                            <Button colorScheme='red' onClick={() => {
                                                onClose()
                                                changeInvoiceStatus(JSON.parse(window.sessionStorage.getItem('invoiceId')), JSON.parse(window.sessionStorage.getItem('newInvoiceTPAmount')), d.invoiceDate, d.invoiceName, "CANCELLED")
                                                window.sessionStorage.removeItem('invoiceId')
                                                window.sessionStorage.removeItem('newInvoiceTPAmount')
                                                
                                                }} ml={3}>
                                                YES
                                            </Button>
                                            </AlertDialogFooter>
                                        </AlertDialogContent>
                                        </AlertDialogOverlay>
                                    </AlertDialog>

                                     {/* PAID STATUS ALERT */}
                                     <AlertDialog
                                            motionPreset='slideInBottom'
                                            onClose={onClose2}
                                            isOpen={isOpen2}
                                            isCentered
                                    >
                                        <AlertDialogOverlay>
                                        <AlertDialogContent>
                                            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                                                Mark as Paid
                                            </AlertDialogHeader>

                                            <AlertDialogBody>
                                                Are you sure? You can't undo this action afterwards.
                                            </AlertDialogBody>

                                            <AlertDialogFooter>
                                            <Button onClick={onClose2}>
                                                NO
                                            </Button>
                                            <Button colorScheme='red' onClick={() => {
                                                onClose2()
                                                changeInvoiceStatus(JSON.parse(window.sessionStorage.getItem('invoiceId')), JSON.parse(window.sessionStorage.getItem('newInvoiceTPAmount')), d.invoiceDate, d.invoiceName, "PAID")
                                                window.sessionStorage.removeItem('invoiceId')
                                                window.sessionStorage.removeItem('newInvoiceTPAmount')
                                                
                                                }} ml={3}>
                                                YES
                                            </Button>
                                            </AlertDialogFooter>
                                        </AlertDialogContent>
                                        </AlertDialogOverlay>
                                    </AlertDialog>


                                    {/* Issue Due Date Invoice Modal */}
                                    <Modal
                                        isOpen={isOpen1}
                                        onClose={onClose1}
                                    >
                                        <ModalOverlay />
                                        <ModalContent>
                                        <ModalHeader textAlign={'center'}>Issue Due Date Invoice</ModalHeader>
                                        <Divider />
                                        <ModalCloseButton />
                                        <ModalBody pb={6}>
                                        <FormControl mt={1}>
                                                    <FormLabel>Due Date Amount</FormLabel>
                                                    <Input type='number' step={'any'}  name={'dueDateAmount'} value={issueDueDateAmount}  onChange={(e) => setIssueDueDateAmount(e.target.value)}/>
                                                </FormControl>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button colorScheme='red' mr={3} onClick={onClose1}>
                                            Cancel
                                            </Button>
                                            <Button colorScheme='blue' isDisabled={!issueDueDateAmount || !(issueDueDateAmount >= 0)} onClick={() => {
                                                issueDueDate(JSON.parse(window.sessionStorage.getItem('invoiceId')), JSON.parse(window.sessionStorage.getItem('newInvoiceTPAmount')), d.invoiceName )
                                                window.sessionStorage.removeItem('invoiceId')
                                                window.sessionStorage.removeItem('newInvoiceTPAmount')
                                                onClose1()
                                            }}>Generate</Button>
                                        </ModalFooter>
                                        </ModalContent>
                                    </Modal>
                                    </Td>
                                </Tr>
                            ))}
                           
                           
                        </Tbody>
                    </Table>
                </TableContainer>
                 :
                      
                                    
                 <Text color={'green.500'} fontSize={'lg'}>Invoice not generated</Text>
                 

                 }

 
        </Box>
    )
}

export default TenureDetailsTable
